export default __webpack_public_path__ + "static/media/green-circle-check.863e76d0d24889c4e6c56156fa6f7479.png";